/* eslint-disable */
import Debugger from 'utils/debugger';
import { llmsActions } from '.';
import LlmsApi from './repository';

export const llmsIdentifyPhoto = (photo) => async (dispatch) => {
  try {
    const conversation = await LlmsApi.createConversation(window.LLMS_VISION_ID);
    if (conversation && conversation.id) {
      const formData = new FormData();
      formData.append('file', photo, photo.name);
      const uploadPhotoResponse = await LlmsApi.uploadPhoto(window.LLMS_VISION_ID, conversation.id, formData);
      if (uploadPhotoResponse) {
        const prompt = '';
        const res = await LlmsApi.sendPrompt(window.LLMS_VISION_ID, conversation.id, prompt);

        const result = {};
        result.visionChatbot = res.vision;
        result.brand = {
          "Clave": res.get_brand_id || null,
        };
        result.model = {
          "Clave": res.get_model_id || null,
        };
        result.version = {
          "Clave": res.get_version_id || null,
        };

        if (res.all_brands && res.all_brands.obj_data && res.all_brands.obj_data.length && result.brand && result.brand.Clave) {
          const foundBrand = res.all_brands.obj_data.find((item) => item.Clave === result.brand.Clave);
          if (foundBrand) {
            result.brand.Nombre = foundBrand.Nombre;
          }
        }

        if (res.all_models && res.all_models.obj_data && res.all_models.obj_data.length && result.model && result.model.Clave) {
          const foundModel = res.all_models.obj_data.find((item) => item.Clave === result.model.Clave);
          if (foundModel) {
            result.model.Nombre = foundModel.Nombre;
          }
        }

        if (res.all_versions && res.all_versions.obj_data && res.all_versions.obj_data.length && result.version && result.version.Clave) {
          const foundVersion = res.all_versions.obj_data.find((item) => item.Clave === result.version.Clave);
          if (foundVersion) {
            result.version.Nombre = foundVersion.Nombre;
          }
        }

        if (res.watches && res.watches.length && result.brand && result.brand.Clave) {
          const foundWatch = res.watches.find((item) => item.Clave === result.brand.Clave);
          if (foundWatch) {
            result.brand.Descripcion = foundWatch.Descripcion;
          }
        }
        dispatch(llmsActions.success(result));
        return result;
      }
    }
  } catch (error) {
    Debugger.error(error);
    return false;
  }
};